const cheque = 2;

export default {
  cheque: cheque,
};
